import { ValueGetterParams } from '@ag-grid-enterprise/all-modules';
import capitalizeFirstLetter from 'utils/valueFormatters/capitalizeFirstLetter';

export const authenticationValueGetter = ({ data }: ValueGetterParams): string => {
  return capitalizeFirstLetter(data.authenType);
};

export default authenticationValueGetter;
